/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
import { useMemo, useState } from 'react';

import { Card, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select, { components } from 'react-select';
import * as Yup from 'yup';
import { ReactComponent as GridIcon } from '../../assets/svg/grid.svg';
import { ReactComponent as ListIcon } from '../../assets/svg/list.svg';
import {
  setModalAction,
  setShowModal,
} from '../../redux/active-tabs/active-tab.action';
import { showToast } from '../../redux/auth/auth.action';
import { searchRCD } from '../../services/contacts';

import { useEffect } from 'react';
import { convertArrayToObject, useDebounce } from '../../helper/comman';
import { getOnlyFirstName, getPublicUrl } from '../../helper/galleyHelper';

import RcdImageComponent from 'comman/component/SelectRcdImage';
import { searchGallery } from 'services/gallery';
import { IMAGE_TYPE } from 'helper/constant/gallery';

const SelectGalleryView = ({
  setShowGalleryModal,
  showGalleryModal,
  onSelect,
  logoType,
}) => {
  const [galleryData, setGalleryData] = useState([]);

  const [filterGallery, setFilterGallery] = useState({
    label: 'Select All',
    value: 'all',
  });

  const [filterGalleryAssign, setFilterGalleryAssign] = useState({
    label: 'Select All',
    value: 'all',
  });

  const [searchText, setSearchText] = useState(() =>
    window.sessionStorage.getItem('gallery_search_text')
  );

  const fetchData = async (value) => {
    const res = await searchGallery({ q: value || '*' });

    if (res.status === 200) {
      if (res.data.total > 0) {
        const galleryList = [];
        res.data?.objects?.forEach((item) => {
          if (
            (item.type === IMAGE_TYPE.LOGO ||
              item.type === IMAGE_TYPE.FULLSCREEN) &&
            item.logoName !== 'DEFAULT_LOGO' &&
            item.logoName !== 'DEFAULT_FULLSCREEN'
          ) {
            try {
              const formatData = {
                ...item,
                imageUrl: getPublicUrl(item.avatar) || '',
                id: item.galleryId || '',
                isLogo: item.type === IMAGE_TYPE.LOGO,
                galleryId: item.galleryId,
                galleryName: item.name || '',
              };

              // Yup.string().url().required().validateSync(item.publicURL, {
              //   abortEarly: false,
              // });

              galleryList.push({ ...formatData });
            } catch (error) {}
          }
        });

        setGalleryData(
          galleryList.map((item) => ({
            ...item,
            contactId: [],
            // contactId: rcdListFull
            //   .filter(
            //     (rcdItem) =>
            //       rcdItem.galleryId === item.galleryId ||
            //       rcdItem.fullScreenId === item.galleryId
            //   )
            //   .map((item) => item._id),
          }))
        );
      } else {
        setGalleryData([]);
      }
    }
  };

  const searchData = useDebounce(async (value) => {
    await fetchData(value);
  }, 300);

  useEffect(() => {
    window.sessionStorage.setItem('gallery_search_text', searchText || '');
  }, [searchText]);

  const filterGalleryData = useMemo(() => {
    let result = [...galleryData];
    if (logoType) {
      switch (logoType) {
        case 'fullImage':
          result = result.filter((item) => !item.isLogo);
          break;
        case 'logo':
          result = result.filter((item) => item.isLogo);
          break;
        default:
      }
    }
    if (filterGalleryAssign) {
      switch (filterGalleryAssign.value) {
        case 'assigned':
          result = result.filter((item) => item.contactId?.length > 1);
          break;
        case 'unassigned':
          result = result.filter((item) => item.contactId?.length === 1);
          break;
        default:
      }
    }
    if (searchText) {
      result = result.filter((item) =>
        (item.galleryName?.toLocaleLowerCase() || '').includes(
          searchText?.toLocaleLowerCase() || ''
        )
      );
    }
    // console.log('result', result);
    return result;
  }, [galleryData, logoType, filterGalleryAssign, searchText]);

  useEffect(() => {
    fetchData(searchText || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      size='lg'
      show={showGalleryModal}
      onHide={() => setShowGalleryModal(false)}
      className='contact-update-modal contact-update-modal-vh'
      backdrop='static'
      key='modal-select'>
      <Modal.Header closeButton>
        <Modal.Title>Gallery</Modal.Title>
      </Modal.Header>
      <Modal.Header className='contact-filter-cs'>
        <div className='row w-100'>
          <div className='col-12 col-md-12 col-lg-12 mr-3'>
            <div className='contact-filter contact-filter-cs mb-3'>
              <div className='input-group d-flex align-items-center'>
                <div className='row flex-wrap flex-lg-nowrap'>
                  <div style={{ width: 400 }} className='col-12 '>
                    <div className='input-group w-100 mb-2 mb-lg-0'>
                      <input
                        className='form-control w-100'
                        type='text'
                        name='search'
                        placeholder='Search'
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                        }}
                      />
                      {searchText && (
                        <svg
                          onClick={() => {
                            setSearchText('');
                            searchData('');
                          }}
                          className='close-icon'
                          xmlns='http://www.w3.org/2000/svg'
                          width='30'
                          height='30'
                          viewBox='0 0 21 21'>
                          <path
                            fill='none'
                            stroke='currentColor'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                            d='m7.5 7.5l6 6m0-6l-6 6'
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  {/* <div className='col-12 col-lg-auto'>
                    <div className='filter-wrapper mb-2 mb-lg-0'>
                      <div className='gallery-sort-type-selectmenu text-nowrap'>
                        <h2>Filter type: </h2>
                      </div>
                      <Select
                        styles={{
                          width: '200px',
                        }}
                        classNamePrefix='select'
                        value={filterGallery}
                        options={[
                          { label: 'Select All', value: 'all' },
                          {
                            label: 'Full Screen',
                            value: 'fullImage',
                          },
                          {
                            label: 'Logo',
                            value: 'logo',
                          },
                        ]}
                        onChange={(opt) => setFilterGallery(opt)}
                      />
                    </div>
                  </div> */}
                  {/* <div className='col-12 col-lg-auto'>
                    <div className='filter-wrapper'>
                      <div className='gallery-sort-type-selectmenu text-nowrap'>
                        <h2>Filter assigned: </h2>
                      </div>
                      <Select
                        styles={{
                          width: '200px',
                        }}
                        classNamePrefix='select'
                        value={filterGalleryAssign}
                        options={[
                          { label: 'Select All', value: 'all' },
                          {
                            label: 'Assigned',
                            value: 'assigned',
                          },
                          {
                            label: 'Unassigned',
                            value: 'unassigned',
                          },
                        ]}
                        onChange={(opt) => setFilterGalleryAssign(opt)}
                      />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            minHeight: '300px',
          }}
          className=''>
          <RcdImageComponent
            galleryData={filterGalleryData}
            setShowGalleryModal={setShowGalleryModal}
            onSelect={onSelect}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = ({
  activeTabReducer: { showModal, modalAction },
  authReducer: { userRole },
}) => ({
  showModal: showModal,
  modalAction: modalAction,
  userRole: userRole,
});

const mapDispatchToProps = (dispatch) => ({
  setToaster: (data) => dispatch(showToast(data)),
  setShowModal: (data) => dispatch(setShowModal(data)),
  setModalAction: (data) => dispatch(setModalAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectGalleryView);
